// removed by extract-text-webpack-plugin
module.exports = {"container":"build_v16-container-k9NByUfNbG2","container--visible":"build_v16-container--visible-kGz9sNVgxqY","tooltip":"build_v16-tooltip-47DApta0wwW","button-close":"build_v16-button-close-gtkvKWiw92c","header":"build_v16-header-lnMUOCLa80G","content":"build_v16-content-a7ioxSNcPKm","text":"build_v16-text-6uKRAZnoiWE","buttons":"build_v16-buttons-dXmC1pKgk8E","button-register":"build_v16-button-register-6WHYQQNXIAC"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/favorite_button/motivation_popup/index.css
// module id = 302
// module chunks = 2